import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import InputComponents from '../components/input';
import ProfileTab from '../components/profileTab'
import { getBusinessDetails, getBusinessDetailsForCustomers, registerPatient } from '../logic/business/action';
import logo from '../images/white_logo.png'
import {MdLocationOn} from 'react-icons/md'
import {IoMdCall} from 'react-icons/io'
import { socket } from '../utils/socket';

const BookAppointment = () => {
  const [isConnected, setIsConnected] = useState(socket.connected);
    const params = useParams();
    const selector = useSelector((state) => state.business);
    const [customer, setcustomer] = useState({full_name:'',email:'',contact:''})
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const onConnect = () =>{
      setIsConnected(true);
    }
    const onDisconnect = () =>{
      setIsConnected(false);
    }
    useEffect(() => {
      const id = params.id.split('_');
      if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){
        getBusinessDetailsForCustomers(dispatch, parseInt((id[id.length - 1])));
      }
        if(!isConnected){
          socket.connect();
        }
    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
        return () => {
    socket.disconnect();
          socket.off('connect', onConnect);
          socket.off('disconnect', onDisconnect);
        };
      }, []);
      console.log(customer.full_name==='');
      console.log(customer.contact==='');
  return (
    <div className='w-screen h-screen bg-blue-700 overflow-hidden'>
        <div className='w-full flex mt-6 justify-center items-center'>
          {
            selector?.details?.url!=null && selector?.details?.url!==''?
            <img src={selector?.details?.url} alt="" width={'100px'} className=''/>
            :
            <img src={logo} alt="" width={'100px'} height={'100px'} className=''/>
          }
        </div>
        <div className='w-full pb-6 lg:px-10 bg-blue-700 text-center'>
                <h4 className='text-white font-bold text-xl text-center'>Welcome to {selector?.details?.name}</h4>
        </div>
        {
          params?.id != null && params?.id !== undefined &&  selector?.details != null ?
        <div className='p-4 lg:p-10 flex items-start justify-start flex-wrap gap-4 bg-white min-h-screen rounded-t-3xl'>
        {/* <div>
          <h1>Fill the details below to Book Appointment</h1>
        </div> */}
        {/* <div className='w-full lg:w-[48%] flex flex-col items-start gap-4'>
        <ProfileTab isEdit={false} name='Business Name' value={selector?.details?.name}/>
        <ProfileTab isEdit={false} name='Business Contact' value={`+91-${selector?.details?.contact}`}/>
        <ProfileTab isEdit={false} name='Business Email' value={selector?.details?.email}/>
        <ProfileTab isEdit={false} name='Business Address' value={selector?.details?.address}/>
        </div> */}
        <div className='w-full lg:w-[48%] mx-auto min-h-full flex flex-col items-center p-4 rounded-lg bg-white gap-4'>
            <h2 className='text-blue-700 font-bold text-2xl text-center'>Fill the details below to <br/> Book Appointment</h2>
            <div className='h-4'></div>
            <InputComponents isRequired={true} value={customer.full_name} name={'full_name'} onChange={(ev)=>setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}))} label={'Full Name *'}/>
            <InputComponents isRequired={true} value={customer.contact} name={'contact'} onChange={(ev)=>{
              if (!Number.isNaN(Number(ev.target.value))) {
                setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}));
              } 
            }} label={'Contact *'}/>
            <InputComponents value={customer.email} name={'email'} onChange={(ev)=>setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}))} label={'Email'}/>
            {/* <input type="text" placeholder='Your Full Name*' name='full_name' id='full_name' value={customer.full_name} onChange={(ev)=>setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}))} />
            <input type="text" placeholder='Your Mobile Number*' name='contact' id='contact' value={customer.contact} onChange={(ev)=>setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}))} />
            <input type="text" placeholder='Your Email Address' name='email' id='email' value={customer.email} onChange={(ev)=>setcustomer((prev)=>({...prev,[ev.target.name]:ev.target.value}))} /> */}
            {/* <div className='flex-1'>

            </div> */}
            <button
            disabled={selector.loading || customer.full_name === '' || customer.contact.length!== 10}
            className='w-full mt-4 disabled:bg-gradient-to-r disabled:from-gray-500 disabled:to-gray-500'
            onClick={()=>{
              if(customer.full_name!=='' && customer.contact.length===10){
                const id = params.id.split('_');
                if(id.length > 1 && !isNaN(parseInt(id[id.length - 1]))){
                  // getBusinessDetailsForCustomers(dispatch, params.id);
                  registerPatient(dispatch,parseInt(id[id.length - 1]),customer,navigate,socket,null,params.id); 
                }
              }
                // console.log(dt);               
            }}
            >Proceed</button>

            {/* <hr className='w-full border'/>
            <div className='flex flex-col items-center gap-2'>
            <h4 className='text-blue-600 font-bold w-full text-center text-lg'>{selector?.details?.name}</h4>
            <div>
            <div className='flex items-center gap-4' ><MdLocationOn size={24} /> {selector?.details?.address}</div>
            <div className='flex items-center gap-4' ><IoMdCall size={24} /> {selector?.details?.contact}</div>
            </div>
            </div> */}
            <div className='bg-[#0B469D] rounded-t-xl w-full fixed bottom-0 left-0 text-white text-center p-2'>
            @theappointmentapp
        </div>
        </div>
        </div>:''
        }
    </div>
  )
}

export default BookAppointment